export default __webpack_public_path__ + "static/media/slide-2.d46754e9.jpg";